import React from 'react'
import { motion } from "framer-motion";
import introthum from '../introImg.png'

export default function Intro() {
  return (
   <section className="bg-gray-10 pt-0 pb-20 px-4">
           <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
   
             {/* Left Image */}
             <motion.div
               initial={{ opacity: 0, x: -80 }}
               whileInView={{ opacity: 1, x: 0 }}
               transition={{ duration: 0.8 }}
               viewport={{ once: true }}
               className="relative"
             >
               <img
                 src={introthum}
                 alt="About"
                 className="rounded-2xl w-full h-auto object-cover"
               />
   
               {/* Badge */}
               <div className="absolute bottom-5 left-5 bg-navy text-white px-6 py-4 rounded-xl shadow-lg">
                 <h2 className="text-2xl font-bold">5+</h2>
                 <p className="text-xs uppercase">Years of Excellence</p>
               </div>
             </motion.div>
   
             {/* Right Content */}
             <motion.div
               initial={{ opacity: 0, x: 80 }}
               whileInView={{ opacity: 1, x: 0 }}
               transition={{ duration: 0.8 }}
               viewport={{ once: true }}
             >
               <p className=" uppercase font-semibold text-lg mb-2 text-dark-gold">
                 About Company
               </p>
   
               <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-navy leading-snug mb-4">
                 Empowering Global Brands through Strategic Tech
               </h2>
   
               <p className="text-gray-600 mb-4 leading-7">
                 Your Company – As our company name indicates we are software consulting
                 and internet services globally. We are one of the fastest growing
                 organizations in internet marketing with client base all over the world.
               </p>
   
               <p className="text-gray-600 mb-6 leading-7">
                 We deliver scalable digital solutions that help businesses grow,
                 innovate, and succeed in a competitive market.
               </p>
   
               {/* Vision & Mission */}
               <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
   
                 <div>
                   <h3 className="font-semibold text-lg text-gray-900 mb-1">
                     Our Vision
                   </h3>
                   <p className="text-sm text-gray-600">
                     To be the global catalyst for digital transformation across every industry.
                   </p>
                 </div>
   
                 <div>
                   <h3 className="font-semibold text-lg text-gray-900 mb-1">
                     Our Mission
                   </h3>
                   <p className="text-sm text-gray-600">
                     Delivering robust, secure, and future-ready IT infrastructure.
                   </p>
                 </div>
   
               </div>
   
               {/* CTA */}
               <button className="flex items-center gap-2 bg-dark-gold p-3 rounded-lg shadow-lg text-white font-medium hover:gap-3 transition">
                 Read Our Story →
               </button>
             </motion.div>
   
           </div>
         </section>
  )
}
